import { Roles } from '@real-estate-portal/enums';
import { ParamsRole } from '@real-estate-portal/interfaces';

export function getParams(role: Roles, params = '', id = ''): ParamsRole {
  return { role, params, id };
}
